import { IconWrapper } from '../runtime';
export default IconWrapper('et_format_s', false, function (h, props) {
  return h("svg", {
    "attrs": {
      "width": props.size,
      "height": props.size,
      "viewBox": "0 0 16 16",
      "fill": "none"
    }
  }, [h("path", {
    "attrs": {
      "d": "M0 2C0 0.895431 0.895431 0 2 0H14C15.1046 0 16 0.895431 16 2V14C16 15.1046 15.1046 16 14 16H2C0.895431 16 0 15.1046 0 14V2Z",
      "fill": "#069E61"
    }
  }), h("path", {
    "attrs": {
      "d": "M0 14H16C16 15.1046 15.1046 16 14 16H2C0.895431 16 0 15.1046 0 14Z",
      "fill": "#008852"
    }
  }), h("path", {
    "attrs": {
      "d": "M8 14H16C16 15.1046 15.1046 16 14 16H8V14Z",
      "fill": "#07B670"
    }
  }), h("path", {
    "attrs": {
      "d": "M5.4356 3.49866C5.93923 2.8772 6.77118 2.45471 8.00891 2.45471C9.72466 2.45471 10.9258 3.58939 11.2606 5.00159H9.68647C9.4115 4.38497 8.81554 3.95471 8.00891 3.95471C7.13707 3.95471 6.76948 4.23514 6.60097 4.44307C6.40566 4.68408 6.35984 4.97551 6.35984 5.11647C6.35984 5.32711 6.46649 5.52108 6.85087 5.74408C7.18055 5.93534 7.56936 6.06377 7.97353 6.19728C8.06533 6.2276 8.15792 6.25818 8.25079 6.28983C8.33582 6.3188 8.44514 6.35209 8.57088 6.39039C8.99067 6.51824 9.59344 6.70182 10.0855 6.96603C10.7714 7.33428 11.4986 7.98475 11.4986 9.10811C11.4986 9.86491 11.0096 10.485 10.4646 10.8767C9.89947 11.2829 9.14868 11.5448 8.35582 11.5448C7.43896 11.5448 6.52819 11.3521 5.82056 10.9003C5.16392 10.481 4.69245 9.83869 4.59766 9.00159H6.12114C6.19393 9.26096 6.36341 9.46719 6.62777 9.63597C7.02045 9.88669 7.62252 10.0448 8.35582 10.0448C8.82869 10.0448 9.27431 9.88499 9.58913 9.6587C9.92412 9.41791 9.99862 9.19465 9.99862 9.10811C9.99862 8.77269 9.82529 8.52886 9.37592 8.28757C9.02675 8.10009 8.65385 7.98629 8.26485 7.86758C8.10156 7.81775 7.93543 7.76705 7.76703 7.70968C7.70409 7.68823 7.63301 7.66498 7.55564 7.63968C7.15216 7.5077 6.57787 7.31984 6.09816 7.04155C5.50624 6.69815 4.85984 6.10261 4.85984 5.11647C4.85984 4.7515 4.95877 4.08705 5.4356 3.49866Z",
      "fill": "white"
    }
  })]);
});